module.exports = __webpack_public_path__ + "img/youtube.6c378143.svg";